export const estudianteState = {
    id: '',
    id_veeduria: '',
    tipo_inst_edu: '',
    nivel: '',
    region: '',
    provincia: '',
    distrito: '',
    inst_educativa: '',

    tipo_doc_hijo: '',
    nacionalidad: '',
    dni: '',
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    genero: '',
    grado: '',
    seccion: '',
    email: '',
    beneficiario: false,
    
    formato: '',
    lista_formato: [],

    region_muni: '',
    provincia_muni: '',
    distrito_muni: '',
    municipalidad: '',
    referencia_muni: '',
    existe_observacion: false,

    isLoading: false,
    isValidated: false,
    message: '',
    severity: '',
}